// Shared constants + pure helpers extracted from App.js during the modular split.
// Kept dependency-free so any component/module can import without circular refs.
//
// The formatters/parser/badge below used to be a byte-for-byte copy of
// lib/format.js's — re-exporting from there instead of maintaining a second
// copy that can silently drift.
export { fmt$, fmtPct, fmtN, fmtZi$, ZI_PAPER_BADGE, parseOCC, ziClass, colorVal } from "./format";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const API_V2 = `${process.env.REACT_APP_BACKEND_URL}/api/omega/v2`;
